var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-ahead-transaction-label",on:{"click":function($event){$event.stopPropagation();return _vm.openPlanDetails($event)}}},[_vm._v(_vm._s(_vm.plan.name)+"  "+_vm._s(_vm.plan.unicodeIcon))])}
var staticRenderFns = []

export { render, staticRenderFns }